<template>
  <div class="overlay-wrap modal active" @click="(e) => closeNotification(e)">
    <div
      class="rounded-card"
      :style="`width: ${ROUNDED_CARD_WIDTH}px; top: ${parentPos.top + parentPos.height + 6}px; left: ${ parentPos.left - ROUNDED_CARD_WIDTH }px;`"
    >
      <span class="rounded-card__title">Notifikasi</span>
      <NotificationContent />
    </div>
  </div>
</template>
<script setup>
import NotificationContent from '../Notification/NotificationContent'
import { defineEmit, onMounted, reactive } from 'vue'

const ROUNDED_CARD_WIDTH = 393

const parentPos = reactive({
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  height: 0
})

const emit = defineEmit(['closenotification'])

onMounted(() => {
  const parentEl = document.getElementsByClassName('notif')[0] || null
  const { top, left, right, bottom } = parentEl.getBoundingClientRect()

  parentPos.height = parentEl.offsetHeight
  parentPos.top = top
  parentPos.left = left
  parentPos.right = right
  parentPos.bottom = bottom
})

const closeNotification = (e) => {
  if (e.target === e.currentTarget) emit('closenotification')
}

</script>
<style lang="scss" scoped>
  .rounded-card {
    position: absolute;
    max-height: 420px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;

    &__title {
      padding: 1em;
      margin-top: .5em;
      font-size: 18px;
      font-weight: 700;
    }
  }
</style>
